export default function useGoogleClientId() {
  return global.__AT_STORE__.googleClientId;
}
